/**
 * Created by mosheborochov on 01/09/16.
 */
'use strict';

export var apiUrl = 'https://api.quel-collegue.com/';
//export var apiUrl = 'https://fdj-api.quel-collegue.com/';
//export var apiUrl = 'http://localhost:8080/';



// WEBPACK FOOTER //
// /Users/mosheborochov/Desktop/work/QCEV/dev/QCEV-FRONT/src/app/global.ts